module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg34.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("Oberst Otto Remer (left), commander of the Führer-Begleit-Brigade, with two of his men photographed during the Ardennes offensive. (Bundesarchiv)")])]), _vm._v(" "), _c('p', {
    staticClass: "chapname",
    attrs: {
      "id": "h2"
    }
  }, [_vm._v("‘Wacht am Rhein’: Order of Battle")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("The order of battle for ‘Wacht am Rhein’ appears in ‘Gliederung der Heeresgruppe B für den befohlenen Angriff’ compiled by Ob.West and dated December 16. The descriptions of the German formations which follow are set out under the commands to which they belonged on December 16 according to that document; this order of battle was to change of course according to tactical demands as the battle developed.")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Besides the main fighting units, divisions and brigades, the document lists the Heerestruppen (GHQ units), for under the flexible German military system, armies and corps were regarded as higher headquarters for directing whichever divisions they were assigned, and they had very few organic units of their own, only services and administration. OKH allocated to the Heeresgruppe, depending on their battle requirements, additional fighting and specialist units and these formations, the Heerestruppen, were then sub-allocated to armies, corps and then divisions. For the most part they were artillery, engineer or assault units. Again, the details for these Heerestruppen units are current as at December 16.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The exact strength of the panzer and panzergrenadier divisions on the eve of the offensive appears in ‘Meldüng über Stand der schw.Waffen der Pz.Divisionen’ (Heavy Weapons Situation of the Panzer Divisions), issued on December 10 by Ob.West, which lists the situation in tanks, assault guns and field guns for fifteen divisions then earmarked for the offensive. Ten of them would be actually involved in ‘Wacht am Rhein’, the other five being engaged later within Heeresgruppe G, mainly for the subsequent offensive launched to the south, Operation ‘Nordwind’. The numbers of tank-destroyers and assault guns equipping the various units engaged as Heerestruppen are to be found on the Ob.West situation maps for the start of the offensive.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In fact, when the time came, because of its favoured position in Hitler’s scheme of things, 6. Panzer-Armee alone retained its original strength as envisaged when the plan was drafted by Jodl in early October. The 5. Panzer-Armee possessed only three of the four panzer divisions once planned, the loss being made up by an extra infantry division. Even more drastic was the plight of 7. Armee. On Hitler’s instructions, its single panzer formation was taken away and nothing arrived to replace it; of the six infantry divisions intended for 7. Armee just four had materialised by December. Yet regardless of this diminution in strength, drawn off in the preceding battles, Hitler held fast to the ambitious objectives had conceived for the operation.")]), _vm._v(" "), _c('p', {
    staticClass: "sec1"
  }, [_vm._v("OKW RESERVE")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nine units appear in the Order Battle of Heeresgruppe B as being OKW reserve, of which five were committed in ‘Wacht am Rhein’ by Heeresgruppe B and the other four by Heeresgruppe G, mainly for Operation ‘Nordwind’. By comparison, Heeresgruppe B reserve consisted of one division — an indication of the degree of initiative left to von Rundstedt and his senior commanders. The five were:")]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("Führer-Begleit-Brigade")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the Führer-Begleit-Bataillon, the brigade originated in 1939 as a motorised escort unit for the Führer and from 1941 was stationed near the Führerhauptquartier at Rastenburg. Elements were sent to the Eastern Front to gain battle experience but Russian pressure soon caused the bulk of the battalion to be sent into action, leaving only a small detachment on guard duties at the Wolfsschanze. In May 1944 it was expanded into a regiment and in November into the Führer-Begleit-Brigade. It soon moved west under the command of Oberst Otto Remer and detrained in the Daun area of the Eifel between December 10 and 13. Now organised as a fighting unit it contained: a panzer regiment, an anti-aircraft regiment, and two motorised battalions of grenadiers plus a bicycle battalion, Gren.Btl.z.b.V. 928. Its panzer regiment was still embryonic: II. Abteilung of Panzer-Regiment ‘Gross Deutschland’ having been transferred to the brigade as its 1st battalion, whilst Stu.Gesch.Brig. 200 acted as a substitute for its 2nd. According to the situation maps, on December 17 Panzer-Regiment ‘Füh.Begleit-Brig.’ then comprised: I. Abteilung with twenty-three Panzer I Vs and twenty Sturmgeschütz; and (in place of II. Abteilung) Stu.Gesch.Brig. 200 with twenty-eight Sturmgeschütz.")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg34a.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg35.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("A StuG III of an assault-gun brigade pictured in the summer of 1944. This table details the composition of such formations. It indicates the troop complement (Kopfstärke), the principal weaponry (Hauptwaffen), and the means of transportation (LKw. u. Zugmittel). The lower section covers the Heerestruppen engineer units and clearly shows the fundamental difference between ‘Pionier’ units (assault engineers), equipped with mortars and flame-throwers, as opposed to the ‘Baupionier’ (construction engineers) who wielded picks and shovels.")])]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("Führer-Grenadier-Brigade")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("The unit originated in April 1943 as the Führer-Grenadier-Bataillon and fought as such on the Eastern Front. Raised to brigade strength in April 1944 it was reorganised at Fallingbostel in September and by mid-October was committed with 4. Armee against a Soviet breakthrough near Gumbinnen in East Prussia. At the end of November it was withdrawn to Cottbus for rest and refit. When the brigade moved west between December 11 and 17 its composition was: a panzer regiment, an artillery battalion, an anti-aircraft battalion, a panzergrenadier regiment of two motorised battalions and one bicycle battalion, Gren.Btl.z.b.V. 929. The brigade commander was Oberst Hans-Joachim Kahler. On December 17, according to the situation maps, Panzer-Regiment ‘Füh.Grenadier-Brig.’ comprised: I. Abteilung with eleven Panzer I Vs and thirty-seven Panthers (a handful of them Jagdpanthers); standing in for II. Abteilung was Stu.Art.Brig. 911 with thirty-four StuGs.")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "sec2"
  }, [_vm._v("9. Volks-Grenadier-Division")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The original 9. Infanterie-Division had been formed in 1935 as one of the early Wehrmacht divisions and had fought in the West in 1940 and on the Eastern Front from 1941. Destroyed in Romania in August 1944, it had been written off on October 9. The 9. Volks-Grenadier-Division which came into being on the west coast of Denmark on October 13 thus bore no resemblance to the former experienced infantry division of old but resulted merely from a change of number, having been formed as the 584. Volks-Grenadier-Division at Esbjerg, where it had been assembling since September; its Stu.Gesch.Kp. 1009 equipping with the Jagdpanzer 38(t) at Milowitz in Czechoslovakia. The division moved out on December 14 and was scheduled to detrain at Gerolstein, to be in readiness west of the town on December 19.")]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("167. Volks-Grenadier-Division")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The 167. Infanterie-Division was another of those veteran divisions which had distinguished itself on the Eastern Front and which disappeared in August 1944 with 8. Armee in Romania. What remained of it, Divisiongruppe 167, was refitted at Dollersheim with the remnants of 17. Luftwaffen-Feld-Division, shattered in France, to become the 167. Volks-Grenadier-Division on September 2, its Stu.Gesch.Kp. 1167 issued with the Jagdpanzer 38(t) at Milowitz. The division was due to arrive in the Gerolstein area on December 24.")]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("3. Panzergrenadier-Division")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As 3. Infanterie-Division it fought in Poland and the West, becoming a motorised infantry division in October 1940. From the summer of 1941 it fought in the East until it was destroyed at Stalingrad. Re-formed in south-west France from 386. Infanterie-Division (mot.), it became 3. Panzergrenadier-Division in June 1943. It fought in Italy until late August 1944 when it was ordered to France to counter the Allied threat in Lorraine and was then moved up to the Aachen sector, being pulled out at the beginning of December. On December 10 the division’s Panzer-Abteilung 103 could field forty-one StuGs and its Panzerjäger-Abteilung 3 twenty-five Jagdpanzer IV/70s, although on the operational charts for the offensive the number of StuGs was put at twenty.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("The other four formations in OKW reserve were 257. Volks-Grenadier-Division, 6. SS-Gebirgs-Division, 11. Panzer-Division, and 10. SS-Panzer-Division, none of which was committed as such, although elements (for instance part of SS-Pz.Art.Rgt. 10) saw action with other units. The introduction of 11. Panzer-Division into the battle was delayed by problems over its transfer from Heeresgruppe G in the south; a disagreement arose between von Rundstedt and the Heeresgruppe G commander, General Hermann Balck, about moving an entire panzer division across a dislocated railway system, and by December 18 the disruption was such that the move had to be called off.")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("All von Rundstedt’s repeated requests for the deployment of these reserves were fruitless, except for both 9. VGD and 167. VGD which were ordered forward on December 23 albeit not released from OKW control. Three days later, when Model made another of his persistent demands to be allowed to make use of the OKW reserve — the armour specifically — he was given control of these two divisions. By this date the three divisions remaining in reserve were already earmarked for Operation ‘Nordwind’.")]), _vm._v(" "), _c('p', {
    staticClass: "sec1"
  }, [_vm._v("HEERESGRUPPE B RESERVE AND OTHER UNITS")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The single division in reserve on the eve of the Ardennes offensive over which Heeresgruppe B had direct control was 79. Volks-Grenadier-Division.")]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("79. Volks-Grenadier-Division")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The original 79. Infanterie-Division had been destroyed during the summer around Jassy in Romania. The new 79. Volks-Grenadier-Division came into being on October 27 by a change of number of 586. VGD, which had been assembling at Thorn (Torun) in Poland since September. When it left for the West on December 11 the division was in poor shape, sorely lacking in transport and with neither its anti-aircraft nor anti-tank unit. Its Stu.Gesch.Kp. 1179, equipping with the Jagdpanzer 38(t) at Mielau, failed to appear in time.")]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("Engineers")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The range of engineer units available to Heeresgruppe B included construction engineers (baupionier-bataillons) and the others required for different tasks — for instance, Schneeräum-Kompanie 226 to carry out snow clearance. Different altogether were the combat or assault engineers (pionier-bataillons) and such units as Panzer-Pionier-Kompanie 813 equipped with miniature, wire-guided, tracked ‘Goliath’ demolition charge carriers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Four bridging columns were allotted: Brückenkolonne or Brüko 888, Brüko 921, Brüko 969 and Brüko 956, each with standard Brückengerät B steel pontoon bridging equipment capable of spanning a river fifty metres wide and of bearing up to ten tonnes, or half that width and taking double the weight. (Brückengerät J pontoon bridging equipment which could span up to eighty-five metres and take up to thirty tonnes — or forty metres and seventy tonnes — was also in service with the armies.)")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg36.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There were also two labour regiments of OT-Brigade 5 belonging to the Reich’s utility service and semi-military, all-purpose construction and engineering concern, Organisation Todt. Taking OT-Regiment 2 as an example, it consisted at that time of 1,500 German and 800 foreign workers.")]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("Artillery")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A unit of long-range railway guns was allotted to Heeresgruppe B. This was the Eisenbahn-Artillerie-Abteilung 725, comprising three batteries: E-Battr. 674, with one 24cm Th.Br. K gun having a range of twenty kilometres; one 24cm Th. K gun, range 28 kilometres, and one 27.4cm K 592(f) gun, range 30 kilometres; E-Battr. 688, with one 28cm K 5 gun, range 60 kilometres and E-Battr. 749 with two 28cm K 5 gl. which had a purported range of up to 125 kilometres!")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg36a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("A detachment of long-range railway guns, Eisenbahn-Artillerie-Abteilung 725, was attached to Heeresgruppe B. The picture shows one of the 70-foot-long, 28cm K5 guns in firing position: such leviathans equipped two batteries of this unit during ‘Wacht am Rhein’. On the first day of the offensive its 38-mile range enabled at least one of them to lob 225kg shells into Malmédy from a position on the railway line east of Monschau.")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg37.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "sec1"
  }, [_vm._v("15. ARMEE")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("As the opening of the attack failed to create the conditions for the follow-up operation in the north 15. Armee was not involved as planned, and on December 18 the two mobile divisions assigned for the thrust from the Venlo area — the 9. Panzer-Division and 15. Panzer-grenadier-Division — were placed in OKW reserve and moved south to the Eifel from where they were committed to the battle. Later two infantry divisions were moved south: 340. Volks-Grenadier-Division and 246. Volks-Grenadier-Division.")])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('p', {
    staticClass: "sec2"
  }, [_vm._v("9. Panzer-Division")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Formed in January 1940 from the 4. Leichte-Division, it fought in the Netherlands, Belgium and France; then in 1941 in the Balkans and southern Russia, moving to the central sector in October and taking part in the summer offensive in 1942 and at Kursk in 1943. Transferred to the southern sector again in the autumn, it was heavily engaged in the battles in the Dnepr bend and, having sustained continuing heavy losses from late 1943, was withdrawn in March 1944 to southern France where it was combined with the 155. Reserve-Panzer-Division. It was moved up to fight in Normandy in August. After the withdrawal from France, it was engaged in the Venlo counter-attack and in counterattacks in the Aachen area against the US First Army. After undergoing a short-term refit it was earmarked for ‘Wacht am Rhein’. On December 10 the division’s Panzer-Regiment 33 was at the following operational strength: I. Abteilung, twenty-eight Panzer IVs; and II. Abteilung, thirty-seven Panthers. The division’s Panzerjäger-Abteilung 50 had ten Jagdpanzer IV/70s operational.")]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("15. Panzergrenadier-Division")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Formed in May 1943 as Division Sizilien (Sicilian) and incorporating the remnants of 15. Panzer-Division which escaped from Tunisia, it was designated 15. Panzergrenadier-Division in July and fought in Italy until the beginning of September 1944, when it was transferred to France. In Lorraine it fought in attempting to counter the Allied advance in the West and in subsequent local counter-attacks, being moved north and engaged in similar attacks from the end of October in the Venlo and Aachen sectors. On December 10 its Panzer-Abteilung 115 possessed fourteen Panzer IVs and thirty StuGs, and its Panzerjäger-Abteilung 33 twenty Jagdpanzer IV/70s and eight StuGs.")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg37a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("This Panther of 9. Panzer-Division has stopped in the open, a perilous position in the summer of 1944. (Bundesarchiv)")])])]), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _c('p', {
    staticClass: "fig"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg38.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('p', {
    staticClass: "imagecaption"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("Taken (like that on ")]), _c('a', {
    attrs: {
      "href": "#/Text/14_Chapter06#page_34"
    }
  }, [_vm._v("page 34")]), _vm._v("-"), _c('a', {
    attrs: {
      "href": "#/Text/14_Chapter06#page_35"
    }
  }, [_vm._v("35")]), _vm._v(") from ‘Gliederung und Hauptarten der fechtenden Heerestruppen’, this table shows the composition for the volks-artillerie corps and the volks-werfer brigades. Those listed here are fully motorised units, a VAK (Volks-Artillerie-Korps) consisting of 3,326 men and 525 vehicles. In a partially-motorised VAK unit the totals were 2.521 and 250 respectively to man the same number (87) of guns. In a partially-motorised VWB there were 2,610 troops and 150 vehicles (compared with 2.933 and 285 respectively in a fully motorised brigade), both manning 108 rocket-launchers.")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg39.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_c('i', [_vm._v("Above:")]), _vm._v(" The dual-purpose 8.8cm anti-tank/field gun – this Pak 43/41 is towed by a SdKfz 6 – equipped the II. Abteilung of a volks-artillerie corps. Below: The III. Abteilung, on the other hand, were equipped with the standard field howitzer, the 10.5cm le FH18 – these le FH18/40 being towed by the RSO prime-mover. (Bundesarchiv)")])]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("Artillery")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("In addition to those artillery units with its thirteen divisions, 15. Armee was assigned:")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("a)")]), _vm._v(" three volks-artillerie corps — Volks-Art.Korps 403, Volks-Art.Korps 407 and Volks-Art.Korps 409;")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("b)")]), _vm._v(" two battalions of light guns — H.Art.Abt. 843 and H.Art.Abt. 992;")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("c)")]), _vm._v(" one battalion of heavy mortars — Mörs.Abt. 628;")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("d)")]), _vm._v(" one battery of heavy guns — Fest. Art.Bttr. 1076;")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("e)")]), _vm._v(" six battalions of heavy guns — H.Art.Abt. 1193, H.Art.Abt. III/139, Fest.Art.Abt. 1513, Fest.Art.Abt. 1301, Fest.Art.Abt. 1308 and Fest.Art.Abt. 1310.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("According to the document ‘Artillerie-Ausstattung der Heeresgruppe B’ dated December 14 this brought the artillery strength of 15. Armee to 792 guns and mortars, of which 177 were 150mm or over — a total which was spread along the length of the 100-kilometre front held by 15. Armee, part of it outside the area of projected operations.")]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("Assault Units")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Allotted to 15. Armee were two assault-gun brigades, Stu.Gesch.Brig. 902 and Stu.Gesch.Brig. 341; two assault gun companies, Stu.Mörs.Kp. 1000 and Stu.Mörs.Kp. 1001, equipped with the huge Tiger Mörser, and a battalion of towed anti-tank guns, Pz.Jg.Abt.(mot.Z) 682. Like most of the German units at this date, they were below strength. Stu.Gesch.Brig. 902 possessed twenty StuGs on the eve of the offensive; the nominal establishment for such a brigade being forty-five. There were only three Tiger Mörsers in Stu.Mörs.Kp. 1000 and four in Stu.Mörs.Kp. 1001; so, for all its impressive size, this mobile assault rocket launcher which fired 380mm spin-stabilized projectiles was too few in number to be of more than limited tactical value.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some of 15. Armee’s artillery and assault units were also soon transferred south to the attacking armies. Thus Stu.Gesch.Brig. 902 and the two Stu.Mörs.Kp. were already assigned to 6. Panzer-Armee on December 16.")]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("Engineers")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To supplement its divisions’ engineers 15. Armee received the following units: Pionier-Btl. 16 (assault engineers); Baupionier-Btl. 434 (construction engineers); bridging columns Brüko 992, Brüko 885 (both with B equipment) and Brüko 914 (with J equipment); and two regiments of OT-Brigade 2.")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg39a.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg40.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("326. Volks-Grenadler-Division")])]), _vm._v(" "), _c('p', {
    staticClass: "sec1"
  }, [_vm._v("6. PANZER ARMEE")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("The army staff had only recently been formed, on September 24, around the remnants of XII. Armeekorps destroyed in July near Minsk, with the addition of members of the staff of the Werhmacht command for Belgium and northern France and from the Waffen-SS. SS-Oberstgruppenführer ‘Sepp’ Dietrich assumed command of the army upon its activation.")])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('p', {
    staticClass: "sec2"
  }, [_vm._v("LXVII. Armeekorps")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The corps staff originated on September 24, 1942, as the LXVII. Reservekorps for overseeing reserve divisions in the West and its head-quarters were in Brussels. On January 20, 1944, it became LXVII. Armeekorps and as part of 15. Armee spent the year in France and the Netherlands. The corps commander was Generalleutnant Otto Hitzfeld.")]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("272. Volks-Grenadier-Division")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The former 272. Infanterie-Division was badly mauled in Normandy and what remained of it was sent to Döberitz and included in the 575. Volks-Grenadier-Division assembling there since August. On September 17 this was redesignated 272. Volks-Grenadier-Division. Its Stu.Gesch.Kp. 1272 was equipped with the Jagdpanzer 38(t) at Milowitz. The division left Döberitz at the beginning of November and took over part of the West Wall in the Monschau area, where from the end of the month it came under increasing pressure from V Corps of the First Army driving for the Rur (Roer) dams.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The 326. Infanterie-Division had been destroyed in Normandy and, on September 4, 1944 a new 326. Volks-Grenadier-Division was created by giving the number to the 579. Volks-Grenadier-Division assembling at Kaposvar in Hungary. It was moved to the Eifel in November and stationed near Gerolstein. The original intention was for it to attack with LVIII. Panzerkorps of 5. Panzer-Armee, but as it was insufficiently mobile — being some 400 horses short, besides vehicles — it became part of LXVII Armeekorps with 6. Panzer-Armee on the northern wing of the attack where less distance had to be covered, assembling in the Kall area on December 10. Its Stu.Gesch.Kp. 1326 was equipped with the Jadgpanzer 38(t) at Milowitz.")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg40a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("Josef ‘Sepp’ Dietrich together with Generalfeldmarschall von Rundstedt at the beginning of 1944, when Dietrich held the rank of SS-0bergruppenführer and was commander of the I. SS-Panzerkorps. By December he had been promoted to SS-Oberstgruppenführer and was in command of 6. Panzer-Armee. (Bundesarchiv)")])]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("I. SS-Panzerkorps")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("The corps was formed on July 27, 1943, in Berlin Lichterfelde. It served on the southern sector of the Eastern Front until the end of the year and was then transferred west to take command of 1. SS-Panzer-Division and 12. SS-Panzer-Division. It was heavily involved in the Normandy battles and the subsequent withdrawal across France. SS-Gruppenführer Hermann Priess had taken command of the corps during the refitting period just before ‘Wacht am Rhein’.")])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_c('p', {
    staticClass: "sec2"
  }, [_vm._v("277. Volks-Grenadier-Division")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The 277. Infanterie-Division had been badly battered in Normandy and its remnants moved to Hungary and incorporated in the 574. Volks-Grenadier-Division assembling in the Budapest area since August. The change of number to 277 took place on September 9. On November 5 the division left Budapest for the West to take over part of the West Wall in the Losheim area. It was to experience difficulties in moving into its assembly area during the two nights preceding the offensive: one of its battalions was not relieved in the line as planned, and the attack had to go ahead without it. Krämer considered the division to have been at eighty per cent strength. Its Stu.Gesch.Kp. 1277 was equipped with the Jagdpanzer 38(t) at Milowitz and could field six assault-guns on the eve of the offensive.")]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("12. Volks-Grenadier-Division")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As 12. Infanterie-Division, before it was merely redesignated a volks-grenadier division on October 9, 1944, it had fought with distinction in Poland, France and on the Eastern Front before being transferred to the West in September, where it fought on the Aachen sector. It was withdrawn from the battle zone around Jülich and Düren during the night of December 2 for a brief rest and refit near Blankenheim. When it moved into its assembly area near Scheid it was estimated by Krämer as having been at eighty per cent strength. According to the division’s commander, Generalmajor Gerhard Engel, the rough number of assault guns received by its Stu.Gesch.Kp. 1012 at Mielau amounted to six StuGs. An experienced infantry division, in good shape, it was regarded by 6. Panzer-Armee as the best of that army’s infantry divisions.")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg41.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("SS-Gruppenfährer Hermann Priess commanded I. SS-Panzerkorps in December 1944.")])]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("3. Fallschirm-Jäger-Division")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Formed in France in October 1943, it fought in Normandy the following summer and suffered heavily around Saint-Lô and in the Falaise pocket. During October it was withdrawn to Oldenzaal in Holland for refitting; most of the replacement troops being Luftwaffe ground personnel. With the promotion of its famous commander, Generalmajor Richard Schimpf, the division was taken over by Generalmajor Walther Wadehn. As few of the replacements had any experience of fighting as infantry, this created a considerable headache for its newly-assigned officers. The new Chief-of-Staff had no idea of what was involved in ground operations, which meant that the Chief-of-Staff of I. SS-Panzerkorps, to which the division had been assigned, had to ask 6. Panzer-Armee for his immediate replacement by someone who did! On the eve of December 16 the division had been able to move only two regiments into its assembly area near Hallschlag and launched its attack with them alone; the third coming up the following night. According to Krämer the division was at seventy-five per cent strength and had no assault guns.")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg41a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("A group of Fallschirmjäger — fighting then as ordinary infantry — during the summer of 1944. (Bundesarchiv)")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg42.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg42a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_c('i', [_vm._v("Above and below:")]), _vm._v(" Panzer IVs of the 12. SS-Panzer-Division early in 1944. The ones above belonged to the third platoon of 6. Kompanie, SS-Panzer-Regiment 12. (Bundesarchiv)")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg42b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("The crewmen in Panzer IV ‘636’ are SS-Sturmmann Georg Fugunt, the loader, and SS-Sturmmann Erich Mora, radio operator. (Bundesarchiv)")])]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("12. SS-Panzer-Division ‘Hitlerjugend’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("Formed as a panzergrenadier division in July 1943 and redesignated a panzer division in October, it first went into action on June 7 in Normandy and was heavily engaged in the vicinity of Caen, becoming one of the rearguard which fought to keep the Falaise Pocket from being closed. Having suffered considerable losses in Normandy and the subsequent withdrawal across France, the division was ordered to the Sulingen area in north-west Germany for rest and refitting. Its well-known commander, SS-Oberführer Kurt Meyer, nicknamed ‘Panzermeyer’, had been taken prisoner during the retreat in September and SS-Standartenführer Hugo Kraas took over the division on November 9.")])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("When the division moved into its assembly area near Sistig, according to the Chief-of-Staff of 6. Panzer-Armee, SS-Brigadeführer Fritz Krämer, it was at ninety per cent strength in manpower and eighty per cent in equipment. On December 10 its SS-Panzer-Regiment 12 consisted of: I. Abteilung with thirty-eight Panthers and thirty-nine Panzer IVs; standing in for II. Abteilung was schwere Panzerjäger-Abteilung 560 with about twenty-five Jagdpanzers in two companies of Jagdpanzer IV/70s and one company of Jagdpanthers. The division’s SS-Panzerjäger-Abteilung 12 had twenty-two Jagdpanzer IV/70s.")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg43.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("Wilhelm Mohnke, then SS-Obersturmbannführer and commander of SS-Panzer-Grenadier-Regiment 26, greets Dietrich during an inspection of the 12. SS-Panzer-Division.")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg43a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("SS-Obersturmbannführer Jochen Peiper, commander of SS-Panzer-Regiment 1. photographed in the autumn of 1944. (Bundesarchiv)")])]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("1. SS-Panzer-Division ‘Leibstandarte-SS Adolf Hitler’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("Formed as a motorised division early in 1941 from the expansion of elements of Hitler’s bodyguard unit, which had served in Poland and the West, it fought in the Balkans and the southern sector of the Eastern Front, being designated a panzer division whilst in France during the latter half of 1942. Except for a brief period in northern Italy (August – October 1943) it remained on the Eastern Front. Heavily engaged west of Kiev, it was transferred to Belgium for rest and refitting in the spring of 1944. It was then engaged against the invasion sustaining heavy losses in the Normandy battles — including Mortain — and the withdrawal from France, and was refitted near Siegburg in Westphalia in November. The young conscripts for this once hand-picked élite formation were described by the commander of its SS-Panzer-Regiment 1 as ‘pretty good considering the standard of replacements assigned at that time’. According to Krämer, when the division moved into its assembly area near Stadtkyll it was at almost ninety per cent strength in manpower and eighty per cent in equipment. On December 10 the I. Abteilung of SS-Panzer-Regiment 1 could field thirty-seven Panthers and thirty-four Panzer IVs, and schwere SS-Panzer-Abteilung 501, attached in the absence of the panzer regiment’s II. Abteilung, could field fifteen Tiger IIs. The division’s SS-Panzerjäger-Abteilung 1 possessed ten Jagdpanzer IV/70s. A further thirty Tigers were in the process of being delivered, and it could be that half of them actually reached the front, as the situation maps for December 17 show thirty Tigers with the division.")])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg43b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("Two panzer crewmen of SS-Panzer-Regiment 1 in Paris en route to Normandy in the summer of 1944.")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg43c.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("Staff conference held by the commander of schwere SS-Panzer-Abteilung 501, Heinz von Westernhagen (in the spotted camouflage denims), in the summer of 1944 when the unit was equipped with the Tiger I. By December it had been issued with the Tiger II. (Bundesarchiv)")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg44.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("A Panther of SS-Panzer-Regiment 2 belonging to the 2. SS-Panzer-Division ‘Das Reich’. (Bundesarchiv)")])]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("II. SS-Panzerkorps")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("Created in July 1942 as the SS-Panzer-Generalkommando, it became known as II. SS-Panzerkorps in June 1943. The corps served on the Eastern Front during the Kharkov and Kursk battles and moved to Italy in the summer of 1943. Then, after a period in France, it moved east again to the Tarnopol area in April 1944. With the Allied landings in Normandy it was hurriedly ordered west to face the invasion and subsequently withdrew to Germany in the autumn. Its commander was SS-Obergruppenführer Wilhelm Bittrich.")])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('p', {
    staticClass: "sec2"
  }, [_vm._v("2. SS-Panzer-Division ‘Das Reich’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As a motorised infantry division, formed during the winter of 1940-41 from the bulk of the SS-Verfügungs-Division, it fought in the Balkans and on the central sector of the Eastern Front, becoming a panzergrenadier division in November 1942 whilst in France during the second half of that year. It took part in the recapture of Kharkov in March 1943 and the battles in the south, and was withdrawn to France for rest and refit in February 1944 after suffering heavy losses west of Kiev, having been designated a panzer division the previous October. After fighting in Normandy, its extrication from the Falaise pocket and withdrawal across France had brought it to the Schnee Eifel area, behind the West Wall, and it had to be refitted again near Paderborn in the autumn. According to Krämer, when it moved into its assembly area near Satzvey the division was up to eighty per cent of its designated strength. On December 10 its armoured regiment, SS-Panzer-Regiment 2, comprised: I. Abteilung, fifty-eight Panthers; II. Abteilung, twenty-eight Panzer IVs and twenty-eight Sturmgeschütz. The division’s SS-Panzerjäger-Abteilung 2 reported twenty Jagdpanzer IV/70s operational.")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg44a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("The ‘Das Reich ’ commander, SS-Brigadeführer Heinz Lammerding "), _c('i', [_vm._v("(left)")]), _vm._v(", with SS-Sturmbannführer Ernst-August Krag, commander of the division’s reconnaissance battalion , when the latter was decorated with the Ritterkreuz on October 20, 1944.")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg44b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("Another Ritterkreuz award ceremony. SS-Obersturmbannführer Otto Meyer, commanding SS-Panzer-Regiment 9 of the ‘Hohenstaufen’, was decorated at Lemberg on the Eastern Front on June 4, 1944. He was killed in France in September. (Fürbringer)")])]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("9. SS-Panzer-Division ‘Hohenstaufen’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Formed at the beginning of 1943 as a panzergrenadier division, it completed its assembly and training in north-east France and became a panzer division in October 1943. It was moved to the Ukraine in March 1944 and fought in the Tarnopol sector, then in June was ordered to return at once to France with II. SS-Panzerkorps to counter the Allied invasion of Normandy. After the retreat, it was only about twenty per cent of its normal complement early in September when quartered near Arnhem, yet shortly afterwards it played a major part in defeating the Allied airborne landings. From October it was reorganised and refitted near Münstereifel, and according to Krämer was at seventy-five per cent strength when it mustered to the south in its assembly area near Schönau. On December 10 the operational strength of its SS-Panzer-Regiment 9 was: I. Abteilung, thirty-five Panthers and twenty-eight StuGs; II. Abteilung, thirty-nine Panzer IVs and twenty-eight StuGs. The division’s SS-Panzerjäger-Abteilung 9 reported twenty-one Jagdpanzer IV/70s.")]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("Assault Units")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("The 6. Panzer-Armee was assigned two assault-gun brigades, Stu.Gesch. Brig. 394 and Stu.Gesch.Brig. 667; an assault-gun battalion, Stu.Pz.Abt. 217, equipped with the Sturmpanzer IV ‘Brummbär’; and a battalion of towed anti-tank guns, Pz.Jg.Abt.(mot.Z.) 683.")])]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Needless to say, even the favoured Waffen-SS army could not expect to receive units at full strength. On December 17 the two brigades could field only eight StuGs between them, and the battalion only eight Brummbärs, although by December 25 the situation had improved somewhat, in that the two brigades then had twenty-five StuGs between them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Other units assigned later were: two battalions of Tigers, schwere Panzer-Abteilung 506 and schwere Panzer-Abteilung(Fk1) 301, and one of panzerjägers, schwere Panzerjäger-Abteilung 519, equipped with Jagdpanthers. On December 17 the two panzer battalions could field twenty-two Tigers and schwere Pz.Jg.Abt. 519 twenty-one Jagd-panthers and StuGs.")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg45.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("Although well under strength, 9. SS-Panzer-Division played a major part in defeating the Arnhem operation. SS grenadiers pictured in the town with StuGs of the army’s Sturm-Geschütz-Brigade 280. (Bundesarchiv)")])]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("Artillery")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Apart from the artillery with its nine divisions, 6. Panzer-Armee had the following units placed under its command:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("a)")]), _vm._v(" three volks-artillerie corps — Volks-Art.Korps 388, Volks-Art.Korps 402 and Volks-Art.Korps 405;")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("b)")]), _vm._v(" three volks-werfer brigades — Volks-Werf.Brig. 4, Volks-Werf.Brig. 9 and Volks-Werf.Brig. 17;")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("c)")]), _vm._v(" four heavy mortar batteries — Mörs.Bttr. 1110, Mörs.Bttr. 1098, Mörs.Bttr. 1120 and Mörs.Bttr. 428;")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("d)")]), _vm._v(" one battery of heavy artillery — Fest.Art.Bttr. 1123.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This gave the army a total of 685 guns, though only 180 of them were 150mm or over, and 340 rocket launchers of which 214 were 150mm, 108 were 210mm and 18 were 300mm.")]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("Engineers")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Again comparatively well off, 6. Panzer-Armee was allotted these additional units:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("a)")]), _vm._v(" three combat engineer battalions — Pi.Btl.73, Pi.Btl. 253 and Pi.Btl. 62;")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("b)")]), _vm._v(" two construction engineers battalions — Baupionier-Btl. 798 and Baupionier-Btl. 59;")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("c)")]), _vm._v(" one bridge building battalion — Pi.Brück.Btl. 655;")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("d)")]), _vm._v(" five bridging columns equipped with Brückengerät B — Brüko 602, Brüko 2/406, Brüko 1/403, Brüko 967 and Brüko 968;")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("e)")]), _vm._v(" four bridging columns equipped with Brückengerät J — Brüko 895, Brüko 844, Brüko 851 and Brüko 175.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Four regiments of OT-Brigade 4 were also allotted to it.")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg45a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("One battalion of a volks-werfer brigade was equipped with six-barrelled 30cm launchers")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg45b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("one battalion with 21cm launchers and six with 15cm launchers, of which some had the self-propelled 15cm Panzerwerfer 42")])])]), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _c('p', {
    staticClass: "fig"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg46c.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("The main outlines of the nominal composition and strength of panzer and Panzerjäger categories of GHQ units which played a part in the fighting. Taken from the OKH ‘Gliederung und Hauptarten der fechtenden Heerestruppen’.")])])]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg46.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("Tiger IIs (SdKfz 182) equipped the schwere Panzer-Abteilung. Although King Tigers are quite often encountered in American ‘after action’ reports, this frequently resulted from misidentification engendered by its largely mythical reputation. Tigers in fact were rarely encountered in battle. Only three heavy tank units took part in ‘Wacht am Rhein’ and all were well below strength. This particular Tiger II of schwere Panzer-Abteilung 503 is in Budapest in October 1944. (Bundesarchiv)")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg46a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("The Jagdpanzer 38(t) ‘Hetzer’ was allotted to the tank destroyer battalions and the assault-gun companies assigned to infantry divisions. Only one such battalion, Panzer-Jäger-Abteilung 741, was engaged in ‘Wacht am Rhein’ but ten infantry divisions had one company at least partly equipped with Hetzers. This particular specimen belonged to the 2. Kompanie of an unidentified unit. (Imperial War Museum)")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg46b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("Although very impressive with its 38cm rocket projector, the very small number of Tiger-Mörser available to Stu.Mörs.Kp. 1000 and Stu.Mörs.Kp. 1001 meant they had little impact on the battle. This particular beast was captured on February 28, 1945.")])])]), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _c('p', {
    staticClass: "fig"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg47.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("The BIV (SdKfz 301), a ‘Sprengstoffträger’ or demolitions charge layer, equipped various panzer (Fkl) battalions or companies. In addition, these units had a normal complement of panzers although StuGs were more common. The s.Pz.Abt. (Fkl) 301, equipped with Tigers, took part in the offensive. (Bundesarchiv)")])])]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg47a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("Sturm-Panzer-Abteilung were nominally equipped with forty-five Sturmpanzer IV ‘Brummbär’ (SdKfz 166) — a 15cm StuH 43 gun mounted on a Panzer IV chassis. Only four such battalions were organised and one of them, Stu.Pz.Abt. 217, was engaged in ‘Wacht am Rhein’. (Bundesarchiv)")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg47b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("Although three schwere Panzerjäger-Abteilung took part in the offensive, the Jagdpanther (SdKfz 173) was rather rare as these units had only one company actually equipped with this formidable tank destroyer. These two Jagdpanthers of s.Pz.Jg.Abt. 654 were pictured in mid-1944. (Bundesarchiv)")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg48.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "sec1"
  }, [_vm._v("5. PANZER ARMEE")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("The first 5. Panzer-Armee had fought in Africa and disappeared with the capitulation in Tunisia in May 1943. A new one originated in France as Panzer-Gruppen Kommando West on January 24, 1944; under the command of General Geyr von Schweppenburg it faced the Allied invasion in Normandy and became the 5. Panzer-Armee in August 1944. General Hasso von Manteuffel took command on September 12 and led it in the Lorraine battles and then around Aachen.")])]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_c('p', {
    staticClass: "sec2"
  }, [_vm._v("LXVI. Armeekorps")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Created as the LXVI. Reservekorps to take command of second-line divisions within Ob.West on September 21, 1942, it became the LXVI. Armeekorps on February 25 of the following year. The corps was based at Clermond-Ferrand when the Allied breakout from Nor-mandy forced it to withdraw to Germany. In December 1944 its commander was General der Artillerie Walter Lucht.")]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("18. Volks-Grenadier-Division")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From being the 571. Volks-Grenadier-Division assembling at Esbjerg in Denmark with the usual gamut of conscripts filling the gaps around the remnants of the 18. Luftwaffen-Feld-Division, it was renamed the 18. Volks-Grenadier-Division on September 2, 1944. Oberstleutnant i. G. Dietrich Moll, Chief-of-Staff of the new division, gave an insight into the activation of the division in Denmark: ‘The division was allocated a cadre of 2,500 men from the Luftwaffe division defeated near the Seine in August and 3,000 men from other Luftwaffe and naval units. The division also received 5,000 men, largely rehabilitated personnel, combed out of various establishments in the zone of interior, the so-called ‘indispensables’ who hitherto had occupied key positions in industry. These groups included very few recent draftees so that the personnel of the division could scarcely be described as young. Not many of the officers or men had seen much action, a fact which was to bear significantly on the coming operations. Germany was in her sixth year of war, yet few men of this division had campaign ribbons or decorations.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was put into the line at the end of October to take over a section of the West Wall north of the Schnee Eifel, a quiet sector in which it was able to rotate units, thus providing its conscripts with some of the experience and training the majority of them badly lacked and licking the division into shape. Its Stu.Gesch.Kp. 1818, equipped at Milowitz, possessed fourteen Jagdpanzer 38(t).")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg48a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("Commander of 5. Panzer-Armee, General Hasso von Manteuffel. (Bundesarchiv)")])]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("62. Volks-Grenadier-Division")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("As the 583. Volks-Grenadier-Division it began assembling from scratch at Neuhammer early in September 1944, and although from September 22 it bore the number of the 62. Infanterie-Division destroyed near Jassy in Romania during the summer, there was no connection between the two. From Neuhammer it was moved at the end of November to the Wittlich area, and from there during the night of December 15 into a part of the line held previously by elements of the 26. Volks-Grenadier-Division which was shifting southwards into its own attack positions. The division’s Stu.Gesch.Kp. 1162 possessed fourteen Jagdpanzer 38(t) with which it had been equipped at Milowitz.")])]), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_c('p', {
    staticClass: "sec2"
  }, [_vm._v("LVIII. Panzerkorps")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Created on July 28, 1943, as the LVIII. Reserve-Panzerkorps, it took part in the occupation of Hungary (Operation ‘Margarethe’) in March 1944 and then moved west. It became the LVIII. Panzerkorps on July 7 and as such it was heavily engaged against the Allies in Normandy; in the autumn it was engaged in Lorraine. The corps commander was General der Panzertruppen Walter Krüger who had taken command in February 1944.")]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("116. Panzer-Division")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The original 16. Infanterie-Division had been motorised in September 1940 and took part in the Balkans campaign and the invasion of Russia. Being redesignated a panzergrenadier division on the Eastern Front in March 1943, it distinguished itself in the Ukraine in the Zaporozhe area but was badly battered near Uman and withdrawn to France where it was refitted with elements of 179. Reserve-Panzer-Division to become the 116. Panzer-Division on March 28, 1944. It fought in Normandy and the ensuing withdrawal across France, which took it to Aachen, and had to be refitted again near Düsseldorf. During the Aachen battles its highly-decorated commander, Generalleutnant Gerhard Graf von Schwerin was relieved following serious allegations about his loyalty made by Nazi officials, prominent among them the local Gauleiter Grohe and Reichsführer Himmler. Von Schwerin (who in February 1945 was promoted to command LXXVI. Panzerkorps in Italy) was succeeded on September 14 by Oberst Siegfried von Waldenburg, promoted to Generalmajor on November 1. On December 10 the division’s Panzer-Regiment 16 consisted of I. Abteilung with forty-three Panthers operational and II. Abteilung with twenty-six Panzer IVs. The division’s Panzerjäger-Abteilung 228 reported thirteen Jagdpanzer IV/70s operational.")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg49.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("A Jagdpanzer IV of Pz.Jg.Abt. 228, from 116. Panzer-Division, with foliage camouflage in the summer of 1944.")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg49a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("General Walter Krüger, LVIII. Panzerkorps and Generalmajor Siegfried von Waldenburg, 116. Panzer-Division. (Bundesarchiv)")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg50.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("The trident insignia on the left-front identifies these Panzer IVs as belonging to Panzer-Regiment 3, these actual panzers being from 8. Kompanie, II. Abteilung.")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg50a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("Note the anti-aircraft mount for the MG34 and the heavier barrel of the weapon when used on tanks. (Bundesarchiv)")])]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("560. Volks-Grenadier-Division")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("The division was formed on October 10 at Moss in Norway and incorporated various elements of garrison units stationed in Norway and Denmark. By the eve of the attack only half of its men had arrived, the rest making their way on foot or by train. As the division’s commander, Generalmajor Rudolf Bader, was in hospital at the time, the initial assault was led by the commander of one of its infantry regiments, Oberst Rudolf Langhaeuser, Grenadier-Regiment 1128, who handed over to Bader on his return on December 27. The division’s Stu.Gesch.Kp. 1560 was equipped with the Jagdpanzer 38(t) at Milowitz but it would seem that none of its assault guns were present when the attack opened; just ten being available some days later.")])]), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_c('p', {
    staticClass: "sec2"
  }, [_vm._v("XXXXVII. Panzerkorps")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Created as the (mot.) XXXXVII. Armeekorps, it became a Panzerkorps on June 21, 1942. From June 1941 to April 1944 the corps commanded units on the Eastern Front before being transferred to the West. It faced the Allied invasion and was later involved in the Lorraine battles. The corps was under the command of General der Panzertruppen Heinrich von Lüttwitz.")]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("2. Panzer-Division")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One of the original three panzer divisions, it was formed on October 15, 1935 at Würzburg and after the Anschluss of March 1938 remained in Vienna. It fought in Poland and France; then in April 1941 in Greece. From there it returned to France and in September joined the drive on Moscow, continuing to fight on the central sector and taking part in the Kursk offensive in the summer of 1943, until transferred to France early in 1944 for refitting after losses suffered defending the middle Dnepr. Heavily engaged in Normandy, after the withdrawal from France to the West Wall it was in a bad way and was transferred again to rest and refit near Wittlich. A new divisional commander, Oberst Meinrad von Lauchert, took over on the very day before the offensive and arrived when the division was already in its assembly area near Neuerburg. The division was then at about eighty per cent strength. On December 10 the Panzer-Regiment 3 reported forty-nine Panthers operational in I. Abteilung, and twenty-six Panzer IVs and twenty-four StuGs in II. Abteilung. The division’s Panzerjäger-Abteilung 38 reported twenty-one StuGs operational.")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg50b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("Oberst Meinrad von Lauchert had taken command of the 2. Panzer-Division just before the start of the offensive. This picture was taken on the Eastern Front when he was commander of Pz.Rgt. 15 of 11. Panzer-Division. (Bundesarchiv)")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg51.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("Generalleutnant Fritz Bayerlein commanded the Panzer-Lehr-Division in December 1944. This picture was taken in Hungary the previous March. (Bundesarchiv)")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg51a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("Oberst Heinz Kokott (photographed here whilst commanding Grenadier-Regiment 337) led the 26. Volks-Grenadier-Division in the Ardennes. (Bundesarchiv)")])]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("Panzer-Lehr-Division")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("Formed on January 10, 1944 around the staff and instructors of the Krampnitz panzer training school and from the demonstration units of various other training schools, which naturally made it something of a crack unit, the division took part in the occupation of Hungary (Operation ‘Margarethe’) in March 1944 and was then moved to France in May. In Normandy it proved one of the main obstacles to the breakout from the bridgehead. It suffered heavily in the Caen and Saint-Lô sectors and after the withdrawal across France was transferred to Paderborn to refit. Although already earmarked for ‘Wacht am Rhein’, it was committed in late November against a thrust by the American Third Army in the Saar and therefore had to undergo an emergency refit around Mayen in early December. To make good its losses, the missing I. Abteilung of the Division’s Panzer-Regiment 130 had been replaced by the schwere Panzerjäger-Abteilung 559, with about fifteen Jagdpanthers and StuGs; II. Abteilung having twenty-three Panthers and thirty Panzer I Vs. The division’s Panzerjäger-Abteilung 130 had fourteen Jagdpanzer IV/70s. When the Panzer-Lehr-Division moved into its assembly area near Kyllburg to take part in ‘Wacht am Rhein’ with 5. Panzer-Armee, it was at about eighty per cent strength. The division’s commander was Generalleutnant Fritz Bayerlein.")])]), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg51b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("According to Bayerlein, Panzer-Lehr-Regiment 130 received some Panthers equipped with the then-revolutionary infra-red night sight during its refit in the late autumn.")])]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("26. Volks-Grenadier-Division")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Continuously engaged on the Eastern Front since July 1941, the 26. Infanterie-Division was withdrawn for refitting to Poznan, Poland, in September 1944 after the punishing battles of the summer in the Ukraine. Merged at Poznan with the 582. Volks-Grenadier-Division which had been assembling there since August, the resultant formation which still had the structure of one of the old infanterie divisions was redesignated the 26. Volks-Grenadier-Division on September 17. Most of its new troops came from the Kriegsmarine, and they were able to blend quickly with the battle-tried members of the old division, so that its renamed counterpart continued in good stead. At the end of November — almost at full strength — it took over positions on the West Wall in the Dasburg area, where it was to launch its attack. (It also happened to be well off for horses, having about 5,000 of them including some hardy beasts from Russia.) Its Stu.Gesch.Kp. 1026, which moved up from Milotwitz, possessed fourteen Jagdpanzer 38(t).")]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("Assault Units")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("An assault gun brigade, namely Stu.Gesch.Brig. 244, and a panzerjäger battalion, s.Pz.Jg.Abt. 653, were assigned to 5. Panzer-Armee. Both were under strength, the brigade having only fourteen StuGs and the battalion nine Jagdtigers. The Jagdtigers were not used as the unit was moved south for Operation ‘Nordwind’. Pz.Jg.Abt. 741 and Stu.Gesch.Brig. 243 were assigned later to the army; the former having twenty Jagdpanzer 38(t) and the latter twenty StuGs on December 17.")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg52.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("Hungary, March 1944: the panzer crews of Panzer-Lehr-Regiment parade in front of their Panthers for inspection.")])]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("Artillery")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("Apart from the artillery with its seven divisions, 5. Panzer-Armee received:")])]), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("a)")]), _vm._v(" three volks-artillerie corps — Volks-Art.Korps 401, Volks-Art.Korps 410 and Volks-Art.Korps 766;")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("b)")]), _vm._v(" three volks-werfer brigades — Volks-Werf.Brig. 7, Volks-Werf.Brig. 15 and Volks-Werf.Brig. 16;")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("c)")]), _vm._v(" one medium howitzer battalion — H.Art.Abt. 460;")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("d)")]), _vm._v(" three heavy batteries — H.Art.Bttr. 1094, H.Art.Bttr. 1095 and Fest.Art.Bttr. 25/975;")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("e)")]), _vm._v(" four heavy mortar batteries — Mörs.Bttr. 1119, Mörs.Bttr. 1099, Mörs.Bttr. 1121 and Mörs.Bttr. 638.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This brought its total to 596 guns, of which no more than 180 were 150mm or over, and 367 rocket launchers — 232 of 150mm, 81 of 210mm and 54 of 300mm.")]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("Engineers")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("5. Panzer-Armee was allotted these additional engineer units:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("a)")]), _vm._v(" two combat engineers battalions — Pi.Btl. 600 and Pi.Btl. 207;")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("b)")]), _vm._v(" two construction engineers battalions — Baupionier-Btl. 803 and Baupionier-Btl. III/999;")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("c)")]), _vm._v(" four bridging columns equipped with Brückengerät B — Brüko 22, Brüko 6, Brüko 1/409 and Brüko 957;")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("d)")]), _vm._v(" four bridging columns equipped with Brückengerät J — Brüko 850, Brüko 846, Brüko 894 and Brüko 892.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was also allotted four regiments of OT-Brigade 3.")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg52a.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg52b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("During training in Hungary, Panthers of the division crossed the Danube using a J-type bridge built near Esztergom.")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg53.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "sec1"
  }, [_vm._v("7. ARMEE")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("The Army was created on August 25, 1939, and in 1940 took part in the Battle of France. It remained as the army of occupation in Brittany and Normandy and in June 1944 found itself facing the Allied invasion. It subsequently withdrew to Germany and took responsibility for defending part of the West Wall. General Erich Brandenberger assumed command on September 3, 1944.")])]), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_c('p', {
    staticClass: "sec2"
  }, [_vm._v("LXXXV. Armeekorps")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Created as Generalkommando Kniess in October 1943 in southern France, it was attached to 19. Armee until December 2, 1944, when it became LXXXV. Armeekorps and transferred to the 7. Armee. Its commander was General der Infanterie Baptist Kniess.")]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("5. Fallschirm-Jäger-Division")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This paratrooper formation was created in March 1944 but it was virtually destroyed in the Falaise pocket, and, when re-formed in the Netherlands from ex-Luftwaffe ground personnel, it was but a shadow of its former self. The replacements — officers and men — were poorly trained for their role as infantry, and there was a lack of cohesion to the extent that during the offensive individual units quite often went completely their own way regardless! Responsibility for this poor state of affairs fell to the lot of its commander, Generalmajor Ludwig Heilmann, a Fallschirmjäger veteran of Crete and Russia who had won fame at the head of F.S.Rgt. 3 in Sicily and Italy and been awarded the Swords to the Knights Cross at Cassino. The division moved into the Bitburg area at the beginning of December and was not badly off for assault guns as it was given the support of Fsch.Stu.Gesch.Brig. 11, under the command of Oberstleutnant Hollunder, though inevitably below strength, at twenty, according to Oberst i. G. Rudolf von Gersdorff, the army Chief-of-Staff.")]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("352. Volks-Grenadier-Division")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The original 352. Infanterie-Division had been destroyed in Normandy during the summer, and the 352. Volks-Grenadier-Division came into being on September 21 by changing the number of the 581. Volks-Grenadier-Division, then assembling on the border with Denmark at Flensburg. Its replacements came mainly from the Kriegsmarine who therefore possessed little or no experience of ground fighting. After a period of training which lasted to mid-November, the division was moved to the Bitburg area to complete its organisation, and by the end of the month had taken over a section of the West Wall between Vianden and Echternach. The division’s commander, Oberst Erich Schmidt, considered it to be in more than good shape for a volks-grenadier division, as it was at almost full strength and displayed a good fighting spirit. Its Stu.Gesch.Kp. 1352, formed at Milowitz, was said by Schmidt to have possessed no more than about half a dozen Jagdpanzer 38(t) at the start of the offensive.")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg53a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("General Erich Brandenberger was the commander of 7. Armee. (Bundesarchiv)")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg54.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("A Major with Fallschirm-Jäger-Regiment 3 in 1942, Ludwig Heilmann was Oberst and commander of 5. Fallschirm-Jäger-Division in December 1944. (Bundesarchiv)")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg54a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("Commander of the LIII. Armeekorps, General von Rothkirch. This picture was taken on March 6, 1945 after he had been taken prisoner by the 4th Armored Division. He had mistaken some tanks of the 27th Tank Battalion near Pütxborn for panzers because of some German prisoners clustered about them! (US Army)")])]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("LXXX. Armeekorps")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("This corps was created in western France from the Höh.Kdo.z.b.V. XXXI. and had its headquarters at Poitiers. It had been attached to 1. Armee until October 1944 when it was transferred to 7. Armee. The corps commander was General der Infanterie Franz Beyer.")])]), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_c('p', {
    staticClass: "sec2"
  }, [_vm._v("276. Volks-Grenadier-Division")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Following the almost complete destruction of the 276. Infanterie-Division in Normandy, a new 276. Volks-Grenadier-Division had come into being in Poland when the number of the 580. Volks-Grenadier-Division was changed on September 4. Rebuilt around wounded veterans not long out of hospital, the division was in poor shape, deficient in leadership and poorly motivated. It moved west from Poland on November 15 and completed its organisation in the area between Bitburg and Echternach, although to mislead both the local population and Allied intelligence companies exchanged billets frequently. It moved up to its start line between the 352. VGD and 212. VGD during the two nights preceding the attack yet none of the StuGs supposedly allotted its Stu.Gesch.Kp. 1276 at Milowitz had put in an appearance.")]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("212. "), _c('b', [_vm._v("Volks-Grenadier-Division")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After three years on the Eastern Front the 212. Infanterie-Division had been badly shattered in the autumn of 1944 during the withdrawal on the Lithuanian sector and its remnants brought back to Schieratz in Poland for refitting. They were incorporated into the 578. Volks-Grenadier-Division assembling there, and the new division was renamed the 212. Volks-Grenadier-Division on September 17. Contrary to what happened with the 276. VGD, the outcome was not to prove a disappointment. At almost full strength in manpower and with well-proven commanders, Brandenburger regarded it as his best division. It had left Poland at the beginning of November and taken over part of the West Wall south of Echternach. When it moved north to reach its start line on the eve of the attack only five StuGs had arrived from Mielau with its Stu.Gesch.Kp. 1212.")]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("LIII. Armeekorps")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The LIII. Armeekorps was formed at Danzig on November 11, 1944 from Generalkommando von Rothkirch which had previously controlled a rear area on the Eastern Front. It then moved west and was given responsibility for the southern wing of 7. Armee. The corps commander was General der Kavallerie Friedrich-Wilhelm von Rothkirch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The forces under LIII. Armeekorps command had the job of anchoring the left wing of 7. Armee along the rugged ‘moat’ of the Sauer and Moselle rivers, and consisted of a motley collection of low-grade units: a punishment battalion, Fest.Inf.Btl. XIII/999; a machine gun battalion of fortress troops, Fest.M.G. Btl. 44; and, well to the rear, an army school near Trier.")]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("Engineers")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Despite the fact that 7. Armee faced two wide rivers — the Our and the Sauer — along the whole of its front, it was not provided with the necessary additional engineer units. On December 12 Brandenberger complained to Jodl about this ‘catastrophic situation’ but his army was given no more and had to make do with the following:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("a)")]), _vm._v(" three engineers battalions — two battalions of Pi.Brig.(mot) 47, and Baupionier-Btl. 677;")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("b)")]), _vm._v(" one bridge building battalion — Pi.Brück.Btl. 605;")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("c)")]), _vm._v(" four bridging columns equipped with Brückengerät B — Brüko 964, Brüko 965, Brüko 966 and Brüko 961;")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("d)")]), _vm._v(" one bridging column equipped with Brückengerät J — Brüko 974.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Also assigned to the army were two regiments of OT-Brigade 1.")]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("Assault units")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The 7. Armee was allotted a battalion armed with static anti-tank guns, namely s.Pz.Jg.Abt. 501 (Fest), and two battalions of towed anti-tank guns, Pz.Jg. Abt.(mot.Z.) 657 and Pz.Jg.Abt. (mot.Z.) 668.")]), _vm._v(" "), _c('p', {
    staticClass: "sec2"
  }, [_vm._v("Artillery")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_vm._v("Augmenting the artillery strength of its four divisions, 7. Armee was allotted:")])]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("a)")]), _vm._v(" two volks-artillerie corps — Volks-Art.Korps 406 and Volks-Art.Korps 408;")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("b)")]), _vm._v(" two volks-werfer brigades — Volks-Werf.Brig. 8 and Volks-Werf.Brig. 18;")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("c)")]), _vm._v(" five heavy batteries: H.Art.Bttr. 1092, H.Art.Bttr. 1093, H.Art.Bttr. 1124, H.Art.Bttr. 1125 and H.Art.Bttr. 660;")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("d)")]), _vm._v(" one heavy mortar battery — Mörs.Bttr. 1122.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This gave 7. Armee a total of 381 guns (just 76 of them 150mm or over) and 248 rocket launchers. Of these, 140 were 150mm, 54 were 210mm and 54 were 300mm.")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("By virtue of the tremendous effort made to implement ‘Wacht am Rhein’, the combat effectives under Ob.West had more than doubled during December to reach 1,322,561 on January 1. The thirteen infantry and five panzer divisions that were to launch the first wave of the offensive consisted of more than 200,000 men supported by just over 600 tanks plus some 1,900 guns and rocket launchers. In their path stood just four American infantry divisions and part of an armoured division, having a combined effective strength of 83,000 men with 242 Sherman tanks, 182 tank destroyers and 394 artillery pieces. Thus, at the expense of weakening every other front, the Germans gained a considerable initial local superiority.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By January 2, on the eve of the Allied attack to eliminate the salient — or ‘bulge’ — created by ‘Wacht am Rhein’, the Germans had committed eight panzer divisions, two panzergrenadier divisions, two panzer brigades and eighteen infantry divisions; the Americans eight armoured, two airborne and sixteen infantry divisions. Although the balance of strength would appear to have been about equal, it had already in fact tilted well towards the Allies — the number of divisions alone failing to provide the true picture of the relative strength of the opposing forces. In reality, the panzer divisions were able to field an average of no more than around ninety to a hundred tanks apiece while the six American ‘triangular’ armoured divisions (the 4th, 6th, 7th, 9th, 10th and 11th) were each assigned 186 medium tanks, and the two ‘square’ armoured divisions (the 2nd and 3rd) 232 each.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Americans also outnumbered the Germans in infantry. Whereas the American infantry divisions were largely at full strength — at around 14,000 men — the German infantry divisions, though they varied greatly, averaged only a little over 10,000 men. A lower figure of around 8,000 represented the numerous volks-grenadier divisions at eighty per cent establishment, whilst an upper figure of 17,000 applied only to three or four divisions at the pre-1944 infanterie-division level.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Taking mobility into account, the difference widened. The German ‘Blitzkreig’ philosophy allowed for the fact that, apart from a limited number of highly mobile, hard-hitting divisions, the bulk of the infantry were transported by rail and were still dependent on horse-drawn transport in the field. Although this may have been a formula for success in 1940, by 1944 its limitations had been exposed when the war in France had developed into one of movement on an unforeseen scale. Now, with the Luftwaffe having long since lost its superiority over the battlefield and with the railways themselves open to attack and disruption, the Americans enjoyed a degree of unsurpassed mechanised mobility that enhanced their efficiency accordingly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("German armour — tanks, assault guns, tank destroyers — sent into action during the course of ‘Wacht am Rhein’ totalled about 1,550. Altogether, the four SS panzer divisions originally with 6. Panzer-Armee operated about 550 of them; the three panzer divisions with 5. Panzer-Armee, plus the 9. Panzer-Division it was later to receive, deployed about 450; and about 280 were fielded by the two panzergrenadier divisions and the two panzer brigades that were to take part in the battle. (These figures are of course inclusive of the armour of those units brought in as substitutes for the battalions the panzer regiments lacked.) The various Panzer-Abteilungs, Panzerjäger-Abteilungs, Stu.Gesch. brigades, and Stu.Gesch. companies deployed around 300.")]), _vm._v(" "), _c('p', {
    staticClass: "sec1"
  }, [_vm._v("LUFTWAFFE UNITS")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After the invasion in Normandy the role of the Luftwaffe fighter force in the West had changed from pure fighter missions to an increasing number of tactical operations in support of the ground forces. The redeployment of the Jagdgeschwader was completed in November and, for the duration of the offensive, all the fighter units on the Western Front were placed under the overall command of Luftwaffen-Kommando West under Generalleutnant Josef Schmidt. As their main task was no longer home air defence, in effect only two fighter groups were left to protect Germany against Allied bombers while ten Jagdgeschwader (JG1, JG2, JG3, JG4, JG6, JG11, JG26, JG27, JG53 and JG77), with thirty-three squadrons between them, were readied in support of the attacking armies. These units, together with three bomber groups (Kampfgeschwader 51, 66, and 76), one ground support group (Schlachtgeschwader 4), one night fighter group (Nachtjagdgeschwader 2) and three night ground support wings (Nachtschlachtgruppen 1, 2, and 20) were placed under the command of II. Jagdkorps, responsible for air operations in support of the offensive. On December 14 all the Geschwader and Gruppe commanders were called together by the recently assigned corps commander, Generalmajor Dietrich Peltz, for a briefing at Bonn-Wahn. Altogether the aircraft at their disposal totalled 40 reconnaissance aircraft, 171 bombers, 91 fighter-bombers and 1,492 fighters.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The III. Flakkorps, commanded by Generalleutnant Wolfgang Pickert, was assigned to Heeresgruppe B for ‘Wacht am Rhein’: its 2. Flak-Division supporting the 6. Panzer-Armee; 1. Flak-Brigade the 15. Armee; 19. Flak-Brigade the 5. Panzer-Armee; and Flak-Regiment 15 the 7. Armee — altogether about 120 guns, half of them heavy.")])]), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg55.jpg"
    }
  })])]), _c('p', {
    staticClass: "imagecaption"
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_vm._v("‘The main task of the Flak forces is to protect the attacking spearheads and units on the march, especially at narrow points, bridges, over terrain offering no cover’ — from an annex to the operational order (see ")]), _c('a', {
    attrs: {
      "href": "#/Text/13_Chapter05#page_32"
    }
  }, [_vm._v("page 32")]), _vm._v("). This 2cm Flakvierling 38 was pictured in firing position in front of its two-wheeled trailer. Steel helmets lie ready for action on ammunition boxes. (UIIstein)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dbe1b52","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/14_Chapter06.vue
// module id = 96
// module chunks = 0